/* eslint-disable */
import { withOktaAuth } from '@okta/okta-react';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import { HOME_PAGE_PATH } from '../../Pages/Home/Home.page.route';
import authActionCreators from '../../State/Store/Auth/Auth.actions';
import OktaSignInWidget from '../OktaSignInWidget/OktaSignInWidget.component';
import LoginPropTypes from './Login.component.props';
import uiActionCreators from 'State/Store/UI/UI.actions';
import envGet from 'Support/Env/Get/EnvGet.support';
const REACT_APP_VERSION = envGet({ key: `REACT_APP_VERSION` })

/**
 * LoginComponent
 * @export
 * @class LoginComponent
 * @extends {React.Component<LoginComponentComposedProps, LoginComponentState>}
 */
class LoginComponent extends React.Component {
  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof LoginComponent
   */
  static propTypes = LoginPropTypes;

  /**
   * Data specific to the `<LoginComponent />` instance
   * @type {LoginComponentState}
   * @memberof LoginComponent
   */
  state = {
    authenticated: null,
  };

  /**
   * componentDidMount
   * @returns {void} void
   * @memberof LoginComponent
   */
  componentDidMount() {
    this.checkAuthentication();
  }

  /**
   * componentDidUpdate
   * @returns {void} void
   * @memberof LoginComponent
   */
  componentDidUpdate() {
    this.checkAuthentication();
  }

  /**
   * checkAuthentication
   * @returns {void} void
   * @memberof LoginComponent
   */
  async checkAuthentication() {
    const { authSevice, authState, services } = this.props;
    // console.log(authSevice, authState)
    if (!authState) {
      return;
    }
    const { authenticated } = this.state;
    // console.log(authState.isAuthenticated, authenticated, services.authService.isAuthenticated())
    if (services.authService.isAuthenticated() !== authenticated) {
      if (!services.authService.isAuthenticated() && authState.isAuthenticated && authenticated === null) {
        window.location.reload();
        return;
      }
      this.setState({ authenticated: services.authService.isAuthenticated() });
      return;
    }
  }

  /**
   * onSuccess
   * @param {any} widget The widget
   * @returns {Function} The callback that takes response as paramater
   * @memberof LoginComponent
   */
  onSuccess = (widget) => async (res) => {
    const { services, actions, history, location } = this.props;
    // console.log('auth success', res)
    try {
      await actions.authLoginSuccess(res, widget.tokenManager);
      actions.uiTriggered({ type: `[LOGIN VERSION] v${REACT_APP_VERSION}` })
    } catch (err) {
      this.onError(widget)(err);
    }
    await this.checkAuthentication();
    // The user can be in another authentication state that requires further action.
    // For more information about these states, see:
    //   https://github.com/okta/okta-signin-widget#rendereloptions-success-error

    // record login action
    await services.notificationService.recordAction(`login`);

    if (location && location.state && location.state.from) {
      history.push(`${location.state.from.pathname}`);
    } else {
      history.push('/');
    }

  };

  /**
   * onError
   * @param {any} widget The widget
   * @returns {Function} The callback that takes response as paramater
   * @memberof LoginComponent
   */
  onError = (widget) => (err) => {
    alert(1)
  };

  /**
   * Render LoginComponent
   * @returns {React.Component} LoginComponent
   * @memberof LoginComponent
   */
  render() {
    const { authenticated } = this.state;
    // console.log(`authenticated: ${authenticated}`)
    if (authenticated === null) {
      return null;
    }
    return authenticated ? <Redirect to={{ pathname: HOME_PAGE_PATH }} /> : <OktaSignInWidget onError={this.onError} onSuccess={this.onSuccess} />;
  }
}

export default compose(
  withOktaAuth,
  withServices,
  withRouter,
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...authActionCreators,
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(LoginComponent);

// export default LoginComponent
